import { render, staticRenderFns } from "./SwitchPage.vue?vue&type=template&id=6d09e6bb&scoped=true&"
import script from "./SwitchPage.vue?vue&type=script&lang=js&"
export * from "./SwitchPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d09e6bb",
  null
  
)

export default component.exports